module.exports = __webpack_public_path__ + "static/media/mententen.09838007.jpg";